var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "details",
    { staticClass: "card card--collapsible", attrs: { open: "" } },
    [
      _c("summary", { staticClass: "card__title card__title--bg-primary" }, [
        _c("h5", [_vm._v(_vm._s(_vm.descripcionItem))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.saldosIniciales, function(saldoInicial, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(saldoInicial.descripcion_bodega) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(parseInt(saldoInicial.cantidad)) +
                            "\n                "
                        )
                      ])
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("tfoot", [
                  _c("tr", [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.saldoInicialTotal) +
                          "\n                "
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card__content" },
            [
              _c("k-table", {
                attrs: {
                  createButton: false,
                  editButton: false,
                  deleteButton: false,
                  filterStatus: false,
                  path: _vm.path,
                  params: {
                    tipo_fecha: _vm.tipo_fecha,
                    desde: _vm.desde,
                    hasta: _vm.hasta,
                    bodegas_id: _vm.bodegas_id,
                    item_id: _vm.itemId
                  },
                  columns: [
                    {
                      display: "Fecha",
                      value: "movimiento.fecha_transaccion"
                    },
                    {
                      display: "Tipo",
                      value: "movimiento.tipo_documento"
                    },
                    {
                      display: "# Documento",
                      value: "movimiento.numero_documento"
                    },
                    {
                      display: "Bodega",
                      value: "movimiento.descripcion_bodega"
                    },
                    {
                      display: "Cantidad",
                      value: "cantidad",
                      numeric: true
                    },
                    {
                      display: "Observación",
                      value: "observacion"
                    }
                  ]
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card mt-2" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", [
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.saldosFinales, function(saldoFinal, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(saldoFinal.descripcion_bodega) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(parseInt(saldoFinal.cantidad)) +
                            "\n                "
                        )
                      ])
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("tfoot", [
                  _c("tr", [
                    _vm._m(6),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.saldoFinalTotal) +
                          "\n                "
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Saldos iniciales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Bodega")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Total")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Movimientos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Saldos finales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Bodega")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Total")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-623d95f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623d95f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/ItemKardex.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-623d95f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/ItemKardex.vue
// module chunks = 0